
import { defineComponent } from 'vue';
import Parallax from 'parallax-js';

export default defineComponent({
  name: 'ParallaxDiv',
  props: {},
  mounted() {
    const scene = this.$refs.div as HTMLDivElement;
    const parallaxInstance = new Parallax(scene);
    if (window.innerWidth < 1400) {
      parallaxInstance.disable();
    }
    // console.log(elem);
    // const parallaxInstance = new Parallax(elem, {
    //   relativeInput: true,
    // });
  },
});
